import React from 'react';
import { SpacingName, TypographyName } from '@doveit/lego';
import { TextAlign } from '../../types';
import PageSection from '../page-section/PageSection';
import TrustpilotWidget from '../trustpilot/trustpilot-widget/TrustpilotWidget';
import { TrustpilotWidgetType } from '../trustpilot/constants';
import { TrustpilotWidgetProps } from '../trustpilot/trustpilot-widget/types';
import Markdown from '../markdown/Markdown';

export interface TrustpilotSectionProps {
  title: string,
  content?: string,
  type: TrustpilotWidgetType,
  theme?: TrustpilotWidgetProps['theme'],
  clickable?: TrustpilotWidgetProps['clickable'],
  padding?: SpacingName | SpacingName[],
}

export const TrustpilotSection: React.FC<TrustpilotSectionProps> = ({
  type,
  title,
  content,
  theme,
  clickable,
  padding,
}) => (
  <PageSection padding={padding}>
    <PageSection.Wrapper withoutPad>
      <PageSection.Title size={TypographyName.H3}>
        <Markdown>
          {title.trim()}
        </Markdown>
      </PageSection.Title>
      {content && (
        <PageSection.Description
          text={content}
          textAlign={TextAlign.CENTER}
          size={TypographyName.H4}
          color="neutrals.dark"
        />
      )}
      <PageSection.Block>
        <TrustpilotWidget
          type={type}
          theme={theme}
          clickable={clickable}
        />
      </PageSection.Block>
    </PageSection.Wrapper>
  </PageSection>
);

export default TrustpilotSection;
